import { SelectableItem } from '../common/selectableItem';

export enum NoticeType {
    High = 100,
    Low = 200,
    PrivateB2B = 300,
    PrivateProject = 400,
    ContractAward = 500,
    ContractRegistry = 600
}

export enum NoticeStatus {
    Live = 200,
    Expired = 300
}

export class NoticeEnumsToSelectList {
    static getStatuses(): Array<SelectableItem<NoticeStatus>> {
        var output = [] as Array<SelectableItem<NoticeStatus>>;

        output.push({ value: NoticeStatus.Live, text: 'Live' });
        output.push({ value: NoticeStatus.Expired, text: 'Expired' });

        return output;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/notices/notice.enums.ts